// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"684":"a385cc59","787":"4d2ddfe9"}[chunkId] + ".chunk.js";
};